export default "__VITE_ASSET__CXxVwPiM__"